var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#f7f7f7"}},[_c('router-view'),_vm._v(" "),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }